import { useState } from "react";

import type { MBCReviewData } from "../types";

import { BriefText } from "./BriefText";
import { BriefTextEditor } from "./BriefTextEditor";
import { EditButton } from "./EditButton";

type BriefCardProps = {
  brief: MBCReviewData["brief"];
  /** When provided, the visual direction becomes editable. */
  onVisualDirectionSave?: (value: string) => void;
};

export function BriefCard({ brief, onVisualDirectionSave }: BriefCardProps) {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <section className="flex flex-col gap-2 rounded-2xl border border-border-secondary bg-bg-primary p-3xl shadow-xs">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-lg font-bold text-text-primary">
          Visual direction
        </h2>
        {onVisualDirectionSave && !isEditing && (
          <EditButton
            label="visual direction"
            onPress={() => setIsEditing(true)}
          />
        )}
      </div>
      {onVisualDirectionSave && isEditing ? (
        <BriefTextEditor
          onCancel={() => setIsEditing(false)}
          onSave={onVisualDirectionSave}
          placeholder="Describe the visual direction"
          value={brief.visualDirection}
        />
      ) : (
        <BriefText
          placeholder="No visual direction yet"
          value={brief.visualDirection}
        />
      )}
    </section>
  );
}
